<div class="azm-loader" role="status" aria-live="polite" [attr.aria-label]="'accessibility.loading' | transloco">
	<ng-lottie [options]="options()" width="88px" height="88px" />
</div>
